import { FC } from 'react'

import { CountryCode } from '@app/consts/Countries'

import { FlagIcon } from '@ui/icons/flags'
import { IconProps } from '@ui/icons/types'

import { CurrencyType } from '@model/WalletDto'

interface CurrencyCodeFlagIconProps extends IconProps {
  currencyType: CurrencyType
}

const currencyCountryCodeMap: Record<Exclude<CurrencyType, 'BTC'>, CountryCode> = {
  USD: 'USA',
  GBP: 'GBR',
  EUR: 'EU',
  PLN: 'POL',
  CHF: 'CHE',
  HKD: 'HKG',
  SGD: 'SGP',
  ZAR: 'ZAF',
  AUD: 'AUS',
  CAD: 'CAN',
  JPY: 'JPN',
  CNH: 'CHN',
  MYR: 'MYS',
  CRC: 'CRI',
  CLP: 'CHL',
  AED: 'ARE',
  ARS: 'ARG',
  BDT: 'BGD',
  BHD: 'BHR',
  BWP: 'BWA',
  BRL: 'BRA',
  CNY: 'CHN',
  COP: 'COL',
  GHS: 'GHA',
  IDR: 'IDN',
  INR: 'IND',
  JOD: 'JOR',
  KES: 'KEN',
  KGS: 'KGZ',
  KRW: 'KOR',
  KWD: 'KWT',
  KZT: 'KAZ',
  LAK: 'LAO',
  MAD: 'MAR',
  MXN: 'MEX',
  NGN: 'NGA',
  NZD: 'NZL',
  OMR: 'OMN',
  PEN: 'PER',
  PHP: 'PHL',
  PKR: 'PAK',
  QAR: 'QAT',
  RUB: 'RUS',
  SAR: 'SAU',
  THB: 'THA',
  TND: 'TUN',
  TRY: 'TUR',
  TWD: 'TWN',
  TZS: 'TZA',
  UGX: 'UGA',
  UZS: 'UZB',
  VND: 'VNM',
}

export const getCurrencyFlagByCountryCode = (
  currencyType: CurrencyType
): CountryCode | undefined => {
  if (currencyType === 'BTC') return undefined

  return currencyCountryCodeMap[currencyType]
}

export const getCurrencyFlagCountryCode = getCurrencyFlagByCountryCode

export const CurrencyCodeFlagIcon: FC<CurrencyCodeFlagIconProps> = (props) => {
  const { currencyType, size = 40 } = props

  const countryCode = getCurrencyFlagCountryCode(currencyType)
  if (countryCode) return <FlagIcon countryCode={countryCode} size={size} />

  return null
}
